<template>
  <el-select
    v-model="model.user"
    filterable
    reserve-keyword
    :disabled="disabled"
    value-key="id"
    :loading="loading"
    :no-match-text="emptyTxt"
    :no-data-text="emptyTxt"
    :placeholder="placeholder"
    @change="selectUser">
    <el-option
      v-for="user in adminUserList"
      :key="user.id"
      :label="user.first_name + ' ' + user.last_name"
      :value="user">
      <span style="margin-left:5px; color: #8492a6; font-size: 13px">{{user.first_name}} {{user.last_name}}</span>
    </el-option>
  </el-select>
</template>
<script>
import userAPI from '@/services/API/user'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'SelectAdminUser',
  props: {
		user : {
      type : Object
    },
    active : {
      type : Boolean,
      default : true
    },
    role: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    currentUser: {
      type: Object,
      default: null
    }
	},
	data() {
		return {
      model : {
        user : null
      },
      searchedUsers : [],
      loading : false
	   }
   },
  computed: {
    placeholder () {
      return this.$i18n.t('common.select.placeholder');
    },
    emptyTxt () {
      return this.$i18n.t('common.select.empty');
    },
    adminUserList () {
      if (this.role != null) {
        return _.filter(this.searchedUsers, u => {
          const roleFound = _.find(u.roles, r => r.role_name === this.role)
          if (roleFound) return true;
          return false;
        })
      }
      return this.searchedUsers;
    },
  },
  components : {
  },
  methods : {
    selectUser(user){
      this.$emit('selected', user);
    },
    fetchSearchedUsers(){
      this.loading = true;
      return userAPI.listAdminUser()
      .then(searchedUsers => {
        this.searchedUsers= searchedUsers;
        this.loading = false;
      });
    },
    getUserById(userId){
      return customerApi.getCustomer(userId)
    }
  },
  watch: {
    user: function(newUser) {
      if (newUser == null) {
        this.model.user = null;
        this.searchedUsers = [];
      } else {
        this.searchedUsers = [newUser];
        this.model.user = newUser;
      }
    }
  },
  created(){
    if(this.user!=null){
      this.getUserById(this.user.id)
        .then(user=>{
          this.searchedUsers.push(user);
          this.model.user = user;
          this.selectUser(user)
        })
    } else {
      this.fetchSearchedUsers()
        .then(() => {
          // Si l'utilisateur courant est spécifié en props et qu'il fait partie de la liste des user admin,
          // alors le le préselectionne par défaut.
          if (this.currentUser != null) {
            const currentAdminUser = _.find(this.adminUserList, u => u.id === this.currentUser.id);
            if (currentAdminUser != null) {
              this.model.user = currentAdminUser;
              this.$emit('selected', this.model.user);
            }
          }
          if (this.model.user === null && _.size(this.adminUserList) === 1) {
            this.model.user = _.head(this.adminUserList);
            this.$emit('selected', this.model.user);
          }
        });
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1;
  }
}
</style>
